import { render } from "./CommentThread.vue?vue&type=template&id=e3f6ee5c&scoped=true"
import script from "./CommentThread.vue?vue&type=script&lang=js"
export * from "./CommentThread.vue?vue&type=script&lang=js"

import "./CommentThread.vue?vue&type=style&index=0&id=e3f6ee5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f6ee5c"]])

export default __exports__